import imageApi from '@umu/umu-image-handle';
import { IUser, SELECTED_CARD } from './type';
import { getDefaultAvatar } from 'businessCommon/src/@utils';

const defaultAvatar = getDefaultAvatar() || require('./images/default-avatar.png');
const classIcon = require('./images/icon-class.png');
const groupIcon = require('./images/icon-group.png');
const departmentIcon = require('./images/icon-department.png');

export const getName = (user: SELECTED_CARD) => {
    if (user.account_type === 'user') {
        user = user as IUser;
        return user.user_name || user.login_name || user.email || user.account;
    } else {
        return user.account;
    }
};

export const getAvatar = (user: SELECTED_CARD) => {
    if (user.account_type === 'user') {
        return (user as IUser).avatar ? imageApi.appendWidth((user as IUser).avatar, 60) : defaultAvatar;
    } else if (user.account_type === 'class') {
        return classIcon;
    } else if (user.account_type === 'group') {
        return groupIcon;
    } else if (user.account_type === 'department') {
        return departmentIcon;
    }
    return '';
};
